import React, { useState } from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx, useWidgetActions } from '../LayoutContext';
import { CasesDashboard } from '../../CaseClient';

// Granular Home-surface widget — wraps CasesDashboard. Renders the KPI
// card row (Open / In Progress / Resolved / Overdue / SLA Compliance) plus
// the opt-in 14-day trends + by-priority + by-type charts.

function HomeCasesDashboard({ node }) {
  const { token, workspaceId } = useLayoutCtx();
  const [refreshKey, setRefreshKey] = useState(0);
  useWidgetActions(node?.id, { refresh: () => setRefreshKey(k => k + 1) });

  if (!workspaceId) return null;
  return <CasesDashboard key={refreshKey} token={token} workspaceId={workspaceId} />;
}

registerWidget({
  type: 'home.cases_dashboard',
  categories: ['home'],
  palette_label: 'Cases dashboard',
  description: 'KPI cards (Open / In Progress / Resolved / Overdue / SLA) plus collapsible 14-day trends and breakdown charts.',
  Component: HomeCasesDashboard,
  configSchema: null,
  publishes: [],
  subscribes: ['xv.RefreshContext'],
  actions: [
    { name: 'refresh', label: 'Reload dashboard', description: 'Re-queries KPI counts and trend data from the server.' },
  ],
  group: 'Home',
});
